export const snbAccordion = (): (() => void) | undefined => {
  const snbNav = document.querySelector('.snb');

  if (!snbNav) return;

  const activeLis = snbNav.querySelectorAll('li.active');
  for (let i = 0; i < activeLis.length; i++) {
    activeLis[i].classList.add('open');
  }

  const handleClick = (e: Event) => {
    const anchor = (e.target as HTMLElement).closest('a');
    if (!anchor) return;

    const li = anchor.parentElement;
    const subMenu = anchor.nextElementSibling;

    if (subMenu && (subMenu.classList.contains('depth03') || subMenu.classList.contains('depth04'))) {
      e.preventDefault();
      li?.classList.toggle('open');
    }
  };

  snbNav.addEventListener('click', handleClick);

  return () => {
    snbNav.removeEventListener('click', handleClick);
  };
};

export const scrollY = () => {
  var supportPageOffset = window.pageXOffset !== undefined;
  var isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';
  var y = supportPageOffset
    ? window.pageYOffset
    : isCSS1Compat
    ? document.documentElement.scrollTop
    : document.body.scrollTop;
  return Math.floor(y);
};

export default {
  snbAccordion,
  scrollY,
};
